export default (() => {
  const completedWalkable = 'evaluationId\n'
+ 'evaluatedAt\n'
+ 'elementId\n'
+ 'elementType\n'
+ 'elementAttemptId\n'
+ 'evaluation {'
+ 'scenarioCorrectness\n'
+ 'completed\n'
+ 'triggeredActions\n'
+ '}';

  const getActivityHistoryById = (cohortId, deploymentId, activityId) => {
    const query = `${'{'
    + ' learn {'
    + ' cohort(cohortId: "'}${cohortId}") {`
    + ` deployment(deploymentId: "${deploymentId}") {`
    + `activity(activityId: "${activityId}") {`
    + 'id\n'
    + 'pathways {\n'
    + 'id\n'
    + 'type\n'
    + 'history {'
    + 'edges {'
    + 'node {'
    + `${completedWalkable}`
    + '}'
    + '}'
    + '}'
    + '}'
    + '}'
    + '}'
    + '}'
    + '}'
    + '}';
    return query;
  };

  return {
    getActivityHistoryById,
  };
})();
